<template>
  <div class="correct-word-section" ref="correctBoard" :style="positionForm">
    <div style="font-weight: 700">Kiểm tra lỗi chính tả</div>
    <div class="ava-sentence-section mt-1" v-html="sentenceWrong"></div>
    <div class="correct-all-btn btn primary mt-2" @click="correctAllWord">
      Sửa lỗi chính tả ({{ wordNotCorrected.length }})
    </div>
    <div class="correct-word-lst" v-show="isShowCorrectWordLst" :style="positionCorrectWordLst" ref="correctWordList">
      <div>Sửa thành</div>
      <div v-html="correctWordLstHTML" class="mt-1 flex-row word-lst"></div>
    </div>
  </div>
</template>

<script>
import {computed, getCurrentInstance, onMounted, ref, watch} from 'vue';
import {close} from '@/commons/globalMessage';
import _ from 'lodash';
export default {
  props: {
    eventEle: {
      type: Object,
      default: {},
    },
    correctWordCallback: {
      type: Function,
      default: () => {},
    },
    sentenceOrigin: {
      type: String,
      default: '',
    },
    wordNotCorrectedOrigin: {
      type: Array,
      default: [],
    },
    rowIndex: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const {proxy} = getCurrentInstance();
    // Kiểm tra chính tả
    let isShowCorrectWordBoard = false;
    const wrongWordLst = ref([]);
    const sentenceWrong = ref('');
    const isShowCorrectWordLst = ref(false);
    const correctWordLstHTML = ref('');
    const currentWordCorrection = ref(null);
    const positionForm = ref('');
    const positionCorrectWordLst = ref('');
    const wordNotCorrected = computed(() => {
      const temp = wrongWordLst.value.filter(e => !e.isCorrected);
      return temp;
    });
    // end kiểm tra chính tả
    const formatString = (template, ...values) => {
      return template.replace(/{(\d+)}/g, (match, index) => values[index]);
    };
    /**
     * Tính toán lại toạ độ của form sửa
     * pntoan 2.5.2024
     * Kiểm tra xem vị trí của con trỏ ấn vào + thêm độ dài/ rộng của form có bị vượt quá màn hình ko
     *  - Vượt quá bên phải thì chuyển pos -> right = parentWidth - left
     *  - Vượt quá bên trên thì chuyển pos -> bottom  = parentHeight - top
     */
    const relocationFormIfOutOfWindow = (element, position) => {
      const elementAtCursor = position.elementAtCursor.getBoundingClientRect();
      let parentPosition = {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      };
      if (element.classList.contains('correct-word-lst') && position.elementAtCursor?.parentElement?.parentElement) {
        const parentElement = position.elementAtCursor?.parentElement?.parentElement.getBoundingClientRect();
        parentPosition = {
          top: parentElement.top,
          left: parentElement.left,
          right: window.innerWidth - parentElement.right,
          bottom: window.innerWidth - parentElement.bottom,
        };
      }
      const widthForm = element.offsetWidth;
      const heightForm = element.offsetHeight;
      let topPos = '';
      let rightPos = '';
      let leftPos = '';
      let bottomPos = '';
      if (elementAtCursor.x + widthForm > window.innerWidth) {
        rightPos = `right: ${window.innerWidth - elementAtCursor.left - parentPosition.right}px`;
      } else {
        leftPos = `left: ${elementAtCursor.left - parentPosition.left}px`;
      }
      if (elementAtCursor.y + heightForm > window.innerHeight) {
        bottomPos = `bottom: ${window.innerHeight - elementAtCursor.top - parentPosition.bottom}px`;
      } else {
        topPos = `top: ${elementAtCursor.top - parentPosition.top + elementAtCursor.height}px`;
      }
      const result = [topPos, leftPos, rightPos, bottomPos].join(';');
      return result;
    };
    onMounted(() => {
      isShowCorrectWordBoard = true;
      positionForm.value = relocationFormIfOutOfWindow(proxy.$refs.correctBoard, {
        elementAtCursor: props.eventEle.target,
      });
      let sentence = _.cloneDeep(props.sentenceOrigin);
      wrongWordLst.value = props.wordNotCorrectedOrigin;
      if (wrongWordLst.value.length > 0) {
        let index = 0;
        let listWordWrong = [];
        wrongWordLst.value.forEach((e, indexWord) => {
          const sentence_toLowerCase = sentence.toLowerCase();
          const indexText = sentence_toLowerCase.indexOf(e.word);
          let startPos = indexText;
          let endPos = indexText + e.word.length;
          sentence =
            sentence.slice(0, startPos) +
            `<span class="wrong-word" position-wrong="${indexWord}">{${index++}}</span>` +
            sentence.slice(endPos);
          const word = props.sentenceOrigin.slice(e.startPst, e.endPst);
          listWordWrong.push(word);
        });
        sentence = formatString(sentence, ...listWordWrong);
        sentenceWrong.value = sentence;
        if (proxy.$refs.correctBoard) {
          proxy.$refs.correctBoard.addEventListener('click', e => {
            e.preventDefault();
            e.stopPropagation();
            /**
             * Xử lý khi nhấn vào từ sai để show ra các từ đúng
             */
            if (e.target.classList.contains('wrong-word')) {
              currentWordCorrection.value = e.target;
              isShowCorrectWordLst.value = true;

              const positionWrong = e.target.getAttribute('position-wrong');
              if (!isNaN(positionWrong)) {
                const wrongWord = wrongWordLst.value[Number(positionWrong)];
                if (wrongWord) {
                  const correctWordLst = wrongWord.correctWord;
                  let htmlBuilder = '';
                  correctWordLst.forEach(word => {
                    htmlBuilder += `<div class="correct-word btn primary">${word}</div>`;
                  });
                  correctWordLstHTML.value = htmlBuilder;
                }
              }
              proxy.$nextTick(() => {
                positionCorrectWordLst.value = relocationFormIfOutOfWindow(proxy.$refs.correctWordList, {
                  elementAtCursor: e.target,
                  parentElement: e.target.parentElement,
                });
              });
            } else if (e.target.classList.contains('correct-word')) {
              /**
               * Xử lý khi nhấn vào từ đúng
               */
              const position = currentWordCorrection.value.getAttribute('position-wrong');
              if (!isNaN(position)) {
                currentWordCorrection.value.textContent = e.target.textContent;
                currentWordCorrection.value.classList.remove('wrong-word');
                isShowCorrectWordLst.value = false;
                if (wrongWordLst.value[Number(position)]) {
                  wrongWordLst.value[Number(position)]['isCorrected'] = true;
                }
                bindingToInput();
              }
            }
          });
          document.addEventListener('click', e => {
            if (!e.target.classList.contains('correct-word') && !e.target.classList.contains('wrong-word')) {
              const isParentError =
                (e.target.parentElement && e.target.parentElement.parentElement.classList.contains('error-spell')) ||
                e.target.parentElement.classList.contains('error');
              if (!isParentError) {
                if (isShowCorrectWordLst.value == false && isShowCorrectWordBoard) {
                  close(proxy);
                  isShowCorrectWordBoard = false;
                  return;
                }
              }
              const isFocusInput =  e.target.classList.contains('ms-input-item');
              if(isFocusInput && isShowCorrectWordBoard){
                close(proxy);
                isShowCorrectWordBoard = false;
                return;
              }
              isShowCorrectWordLst.value = false;
            }
          });
        }
      }
    });
    /**
     * Sửa tất cả các lỗi chính tả
     * Nếu lỗi nào có nhiều hơn 1 cách sửa thì mặc định lấy cách sửa đầu tiên
     * pntoan 2.5.2024
     */
    const correctAllWord = () => {
      if (wrongWordLst.value.length > 0) {
        const wrongWordEle = document.getElementsByClassName('wrong-word');
        const wrongWordLen = Array.from(wrongWordEle).length;
        Array.from(wrongWordEle).forEach(item => {
          const position = item.getAttribute('position-wrong');
          if (!isNaN(position)) {
            item.textContent = wrongWordLst.value[Number(position)].correctWord[0];
            item.classList.remove('wrong-word');
            wrongWordLst.value[Number(position)]['isCorrected'] = true;
          }
        });

        if (wrongWordLen > 0) {
          bindingToInput();
        }
      }
    };
    /**
     * Bind dữ liệu vào ô input
     * callback ngược lại lấy các control để tự bind trên control
     * pntoan 2.5.2024
     */
    const bindingToInput = () => {
      const sentenceSection = document.getElementsByClassName('ava-sentence-section');
      if (Array.from(sentenceSection).length > 0) {
        const dataCallback = {
          internalText: sentenceSection[0].textContent,
          wordNotCorrected: wordNotCorrected.value,
          rowIndex: props.rowIndex,
        };
        if (typeof props.correctWordCallback == 'function') {
          props.correctWordCallback(dataCallback);
        }
        const hasAllCorrectWord = wrongWordLst.value.filter(e => !e.isCorrected);
        if (hasAllCorrectWord.length == 0) {
          if (isShowCorrectWordBoard) {
            close(proxy);
            isShowCorrectWordBoard = false;
          }
        }
      }
    };
    return {
      wrongWordLst,
      correctAllWord,
      sentenceWrong,
      isShowCorrectWordLst,
      correctWordLstHTML,
      wordNotCorrected,
      positionForm,
      positionCorrectWordLst,
    };
  },
};
</script>

<style lang="scss" scoped>
.correct-word-section {
  position: absolute;
  z-index: 10000;
  background: #fff;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  padding: 8px;
  max-width: 300px;
  border-radius: 5px;
}
.correct-all-btn {
  width: fit-content;
  padding: 4px 10px;
  border-radius: 10px;
  cursor: pointer;
}
.correct-word-lst {
  position: absolute;
  z-index: 10001;
  min-width: 200px;
  padding: 10px;
  height: fit-content;
  background: #fff;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  border-radius: 7px;
}
.word-lst {
  gap: 5px;
  text-align: center;
}
:deep(.wrong-word) {
  border-bottom: 1px solid red;
  background: #ffe5e5;
  cursor: pointer;
  user-select: none;
}
:deep(.correct-word) {
  border-radius: 10px;
  padding: 3px 7px;
  min-width: 30px;
  cursor: pointer;
}
</style>
